import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import CreateRangeModal from '../component/CreateRangeModal';
import UpdateRangeModal from '../component/UpdateRangeModal';
import * as actions from '../action';
import * as c from '../constant';

function rangeCalculation({
  newOtherFeesId,
  removeRangeFees,
  getNewOtherFeesList,
  getSingleNewOtherFees,
  history,
  rangeCalculationList,
  getRangeCalculationList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getRangeCalculationList(newOtherFeesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getRangeCalculationList(newOtherFeesId);
  }, [newOtherFeesId]);

  const handleAddRangeModal = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <CreateRangeModal
          newOtherFeesId={newOtherFeesId}
          rangeCalculationList={rangeCalculationList}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Range Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEditRangeModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateRangeModal
          newOtherFeesId={newOtherFeesId}
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
          rangeCalculationList={rangeCalculationList}
        />
      ),
      title: 'Update Range Fee',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveRange = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to remove this range fee?',
      () => {
        removeRangeFees(data.id, newOtherFeesId, () => {
          getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
          history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
          getSingleNewOtherFees(newOtherFeesId);
          getRangeCalculationList(newOtherFeesId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div>
      <div className="p-3">
        <div className="ml-auto text-right mb-3">
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
            onClick={handleAddRangeModal}
          >
            Add Range Calculation
          </button>
        </div>
        <table className="transaction-table table table-bordered table-sm table-striped table-hover">
          <thead>
            <tr>
              <td>From</td>
              <td>To</td>
              <td>Amount</td>
              <td className="text-center">Action</td>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(rangeCalculationList) ? (
              rangeCalculationList.map((item) => (
                <tr key={item.id} className="top-border">
                  <td className="text-left">
                    {_.get(item, 'attributes.from')}
                  </td>
                  <td className="text-left">{_.get(item, 'attributes.to')}</td>
                  <td className="text-left">
                    {_.get(item, 'attributes.amount')}
                  </td>
                  <td className="text-right">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEditRangeModal(item)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemoveRange(item)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

rangeCalculation.propTypes = {
  rangeCalculationList: PropTypes.instanceOf(Object).isRequired,
  removeRangeFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getRangeCalculationList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  rangeCalculationList:
    _.get(api, `${c.GET_RANGE_CALCULATION_LIST}.list`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(rangeCalculation);
